import { Pipe, PipeTransform, inject } from '@angular/core';
import { _, TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'guestAccessStatus' })
export class GuestAccessStatusPipe implements PipeTransform {
    private translate = inject(TranslateService);

  private labels: string[] = [];
  constructor() { 
    this.labels = [
      this.translate.instant(_('dashboard.guests_not_arrived_yet')),
      this.translate.instant(_('dashboard.guest_arrived')),
      this.translate.instant(_('dashboard.guest_rejected_but_here')),
    ];
  }

  transform(value: number | string, args?: any): any {
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    return this.labels[numValue];
  }
}
